import { Pipe, PipeTransform } from '@angular/core';
import { CustomProduct } from '@product/const';

@Pipe({
  name: 'sdProductIsAvailable',
  standalone: false,
})
export class ProductIsAvailablePipe implements PipeTransform {
  transform(product: CustomProduct): boolean {
    return Boolean(product.unit && product.stock?.stockLevelStatus !== 'outOfStock' && !product.isArchive);
  }
}
